<template>
    <div class="mining">
        <div class="placeholder"></div>
        <div class="mining-content mining-warp">
            <div class="mining-title">
                {{$t('mining.title')}}
            </div>
            <div class="mining-card">
                <div class="mining-card-item">
                    <div>
                        <div class="value">
                            <span> {{dayTotal}}<i></i></span>
                        </div>
                        <div class="label">{{$t('mining.day')}}(USDT)</div>
                    </div>
                    <div>
                        <img src="../../assets/img/mining/card-img.png" alt="">
                    </div>
                </div>
                <div class="mining-card-item">
                    <div>
                        <div class="value">
                            <span> {{box}}</span>
                        </div>
                        <div class="label">{{$t('mining.activate')}}</div>
                    </div>
                    <div>
                        <div class="value">
                            <span> {{mining}}</span>
                        </div>
                        <div class="label">{{$t('mining.miningrig')}}</div>
                    </div>
                </div>
            </div>

            <div class="mining-card1" v-for="(item,i) in datalist" :key="i">
                <div class="mining-card1-t">
                    <div class="img-box">
                        <img src="../../assets/img/mining/icon.png" alt="">
                    </div>
                    <div class="label">
                        <div>
                            <span>矿机</span>
                            <span class="tag"><i></i>{{getTags(item.SId,item.EWAP)}}  </span>
                        </div>
                        <div class="time"> {{$t('mining.time')}} {{formatTime(item.AddTime)}}</div>
                    </div>
                </div>
                <div class="mining-card1-b">
                    <div>
                        <div class="value">{{item.SId}}</div>
                        <div class="label">{{$t('mining.remaining')}}</div>
                    </div>

                    <div>
                        <div class="value green">+{{item.EWAP}}</div>
                        <div class="label">{{$t('mining.today')}}(USDT)</div>
                    </div>

                    <div>
                        <div class="value">+{{item.Fee}}</div>
                        <div class="label">{{$t('mining.total')}}(USDT)</div>
                    </div>
                </div>
            </div>

<!-- 
            <div class="mining-card1">
                <div class="mining-card1-t">
                    <div class="img-box">
                        <img src="../../assets/img/mining/icon.png" alt="">
                    </div>
                    <div class="label">
                        <div>
                            <span>XXXX{{$t('mining.dataCapsule')}}</span>
                            <span class="tag red"><i></i> {{$t('mining.expired')}} </span>
                        </div>
                        <div class="time"> {{$t('mining.time')}} 2026.03.22 15:15</div>
                    </div>
                </div>
                <div class="mining-card1-b">
                    <div>
                        <div class="value">3</div>
                        <div class="label">{{$t('mining.remaining')}}</div>
                    </div>

                    <div>
                        <div class="value green">+2.3</div>
                        <div class="label">{{$t('mining.today')}}(USDT)</div>
                    </div>

                    <div>
                        <div class="value">+200.03</div>
                        <div class="label">{{$t('mining.total')}}(USDT)</div>
                    </div>
                </div>
            </div>


            <div class="mining-card1">
                <div class="mining-card1-t">
                    <div class="img-box">
                        <img src="../../assets/img/mining/icon.png" alt="">
                    </div>
                    <div class="label">
                        <div>
                            <span>XXXX{{$t('mining.dataCapsule')}}</span>
                            <span class="tag grey"><i></i> {{$t('mining.stop')}} </span>
                        </div>
                        <div class="time"> {{$t('mining.time')}} 2026.03.22 15:15</div>
                    </div>
                </div>
                <div class="mining-card1-b">
                    <div>
                        <div class="value">0</div>
                        <div class="label">{{$t('mining.remaining')}}</div>
                    </div>

                    <div>
                        <div class="value">0</div>
                        <div class="label">{{$t('mining.today')}}(USDT)</div>
                    </div>

                    <div>
                        <div class="value">+200.03</div>
                        <div class="label">{{$t('mining.total')}}(USDT)</div>
                    </div>
                </div>
            </div> -->
        </div>

    </div>
</template>

<script>
import {
    Field,
    Swipe,
    SwipeItem,
    Circle,
    Tab,
    Tabs,
    Popup,
    Progress,
    Button,
} from "vant";
import { copyToClipboard } from "@/utils";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";

import axios from 'axios'
import contractaa from '../contract/index.js'

export default {
    name: "mining",
    components: {
        SplitText,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            value: "1",
            show: false,
            value1: '100',
            value2: '134.5',
            value3: '134.5',
            dayTotal:0,
            box:0,
            mining:0,
            datalist:[]
        };
    },
    computed: {},
   
    methods: {
        getInfo() {
            let that = this;
            let _token = this.$store.state.loginToken
            _token = encodeURIComponent(_token)
            axios.post(contractaa.APIURL+'?cmd=mining','token='+ _token).then(function (response) {
            if (response.status === 200) {
                    if(response.data.Status){
                        //console.log(JSON.stringify(response.data))
                        var _msg = response.data.Message
                        that.dayTotal = _msg.split('|')[0]
                        that.mining = _msg.split('|')[1]
                        that.box = _msg.split('|')[2] - _msg.split('|')[3] 
                        that.datalist = response.data.Data

                    }else{
                        that.$toast.fail(response.data.Message)
                    }

                }
            })
        },
        getTags(sid,ewap){
            console.log(sid,ewap)
            if(sid<=3 && ewap>0){
                return "即将停产"
            }else if(sid==0 && ewap==0){
                return "停产"
            }else{
                return "正在产出"
            }
            
        },
        formatTime(timeStr){
            let clean = timeStr.replace('T',' ').slice(0,-4)
            return clean
        }
        
    },
    mounted() {
        let timer = setInterval(async () => {
            if (true) {
                this.getInfo()
                clearInterval(timer)
            }
        }, 500);
    },
};
</script>

<style lang="less" scoped>
.mining {
    position: relative;

    .placeholder {
        // height: 50px;
    }

    .mining-warp {
        padding: 0 20px;
    }

    &-title {
        margin-top: 20px;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        color: #FFFFFF;
    }

    &-card {
        width: 335px;
        height: 140px;
        background: url('../../assets/img/mining/card-bg.png') no-repeat;
        background-size: 100% 100%;
        margin-top: 10px;
        margin-bottom: 15px;

        &-item {
            display: flex;
            min-height: 70px;
            justify-content: space-between;

            >div {
                flex: 1;
                padding: 14px 0 13px 15px;
                position: relative;

                .value {
                    color: #FFFFFF;
                    margin-bottom: 5px;
                    font-size: 18px;
                    font-weight: bold;
                    font-family: DINAlternate, DINAlternate;
                    line-height: 21px;

                    i {
                        font-size: 14px;
                        font-style: normal;
                    }
                }

                .label {
                    font-size: 12px;
                    color: #838383;
                    line-height: 17px;
                }

                >img {
                    position: absolute;
                    top: -15px;
                    right: 19px;
                    width: 116.68px;
                    height: 91px;
                }
            }
        }
    }

    &-card1 {
        background: #1B1C1E;
        height: 128px;
        border-radius: 16px;
        padding: 15px;
        margin-bottom: 10px;

        &-t {
            display: flex;

            .img-box {
                border-radius: 8px;
                width: 40px;
                height: 40px;
                background: url('../../assets/img/mining/img-warp.png') no-repeat;
                background-size: 100% 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 10px;

                img {
                    width: 31px;
                    height: 24px;
                }
            }

            .label {
                >div {
                    display: flex;
                    align-items: center;
                }

                span {
                    font-size: 12px;
                    line-height: 17px;
                    font-weight: 600;
                    color: #FFFFFF;
                }

                .tag {
                    font-size: 10px;
                    color: #78E0A4;
                    line-height: 12px;
                    font-weight: 400;
                    margin-left: 9px;
                    background: rgba(120, 224, 164, 0.08);
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 3px 4px;

                    i {
                        margin-right: 3px;
                        display: inline-block;
                        width: 4px;
                        height: 4px;
                        background: #78E0A4;
                        border-radius: 50%;
                    }

                    &.green {
                        color: #78E0A4;
                        background: rgba(120, 224, 164, 0.08);

                        i {
                            background: #78E0A4;
                        }
                    }

                    &.red {
                        color: #FF523F;
                        background: rgba(255, 82, 63, 0.08);

                        i {
                            background: #FF523F;
                        }
                    }

                    &.grey {
                        color: #858585;
                        background: rgba(190, 190, 190, 0.08);

                        i {
                            background: #858585;
                        }
                    }
                }

                .time {
                    margin-top: 5px;
                    font-size: 10px;
                    color: #838383;
                    line-height: 14px;
                    font-weight: 400;
                }
            }
        }

        &-b {
            display: flex;
            justify-content: space-between;
            margin-top: 19px;

            >div {
                .label {
                    font-size: 10px;
                    color: #838383;
                    font-weight: 400;
                    line-height: 14px;
                }

                .value {
                    font-weight: bold;
                    font-family: DINAlternate, DINAlternate;
                    font-size: 14px;
                    line-height: 16px;
                    color: #FFFFFF;
                    margin-bottom: 4px;

                    &.green {
                        color: #27BB3D;
                    }
                }
            }
        }

    }

}
</style>
<style lang="less"></style>